import React from "react";
import Marquee from "react-fast-marquee";

const ITEMS = [
  "24/7 AI Website Agents",
  "Stop Losing Leads After Hours",
  "Turn Visitors Into Booked Appointments",
  "Deployed in 1 Week",
  "1-Year Warranty Included",
];

export default function Ticker() {
  return (
    <div data-testid="ticker-banner" className="bg-white text-[#0A0F1E] border-b border-[#0A0F1E]/10">
      <Marquee speed={36} gradient={false} pauseOnHover={false}>
        <div className="flex items-center py-3 text-[0.78rem] md:text-sm tracking-[0.22em] uppercase font-medium">
          {Array.from({ length: 4 }).map((_, batch) => (
            <React.Fragment key={batch}>
              {ITEMS.map((t, i) => (
                <span key={`${batch}-${i}`} className="flex items-center">
                  <span className="px-6">{t}</span>
                  <span className="text-[#0A0F1E]/30">·</span>
                </span>
              ))}
            </React.Fragment>
          ))}
        </div>
      </Marquee>
    </div>
  );
}
